module.exports = __webpack_public_path__ + "static/media/people_dark.55217410.svg";